import { render, staticRenderFns } from "./the-journey-of-miracles.vue?vue&type=template&id=507cb094&scoped=true&"
import script from "./the-journey-of-miracles.vue?vue&type=script&lang=js&"
export * from "./the-journey-of-miracles.vue?vue&type=script&lang=js&"
import style0 from "./the-journey-of-miracles.vue?vue&type=style&index=0&id=507cb094&prod&lang=css&"
import style1 from "./the-journey-of-miracles.vue?vue&type=style&index=1&id=507cb094&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507cb094",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
